// options for currencies, transaction types and payment methods for transactions
export const transactionTypes = [
  'Grocery',
  'Transportation',
  'Entertainment',
  'Food',
  'Other',
]
export const paymentMethods = [
  'Amex',
  'Credit Card',
  'Cash',
  'Debit Card',
  'Gift Card',
  'Points',
  'WeChat Pay',
  'Alipay',
  'Cryptocurrency',
  'Other',
]
export const currencies = [
  { code: '00', name: '00 Token' },
  { code: '1inch', name: '1inch' },
  { code: 'aave', name: 'Aave' },
  { code: 'abt', name: 'Arcblock' },
  { code: 'ach', name: 'Alchemy Pay' },
  { code: 'acs', name: 'ACryptoS' },
  { code: 'ada', name: 'Cardano' },
  { code: 'aed', name: 'UAE Dirham' },
  { code: 'aergo', name: 'Aergo' },
  { code: 'afn', name: 'Afghan Afghani' },
  { code: 'agld', name: 'Adventure Gold' },
  { code: 'aioz', name: 'Aioz Network' },
  { code: 'alcx', name: 'Alchemix' },
  { code: 'aleph', name: 'Aleph.im' },
  { code: 'algo', name: 'Algorand' },
  { code: 'alice', name: 'My Neighbor Alice' },
  { code: 'all', name: 'Albanian Lek' },
  { code: 'amd', name: 'Armenian Dram' },
  { code: 'amp', name: 'Amp' },
  { code: 'ang', name: 'Netherlands Antillean Guilder' },
  { code: 'ankr', name: 'Ankr Network' },
  { code: 'ant', name: 'Aragon' },
  { code: 'aoa', name: 'Angolan Kwanza' },
  { code: 'ape', name: 'ApeCoin' },
  { code: 'api3', name: 'API3' },
  { code: 'apt', name: 'Aptos' },
  { code: 'ar', name: 'Arweave' },
  { code: 'arb', name: 'Arbitrum' },
  { code: 'arpa', name: 'ARPA Chain' },
  { code: 'ars', name: 'Argentine Peso' },
  { code: 'asm', name: 'Assemble Protocol' },
  { code: 'ast', name: 'AirSwap' },
  { code: 'ata', name: 'Automata Network' },
  { code: 'atom', name: 'Cosmos' },
  { code: 'auction', name: 'Bounce Token AUCTION' },
  { code: 'aud', name: 'Australian Dollar' },
  { code: 'audio', name: 'Audius' },
  { code: 'aurora', name: 'Aurora' },
  { code: 'avax', name: 'Avalanche' },
  { code: 'avt', name: 'Aventus' },
  { code: 'awg', name: 'Aruban Florin' },
  { code: 'axl', name: 'Axelar' },
  { code: 'axs', name: 'Axie Infinity' },
  { code: 'azn', name: 'Azerbaijani Manat' },
  { code: 'badger', name: 'Badger DAO' },
  { code: 'bake', name: 'BakeryToken' },
  { code: 'bal', name: 'Balancer' },
  { code: 'bam', name: 'Bosnia-Herzegovina Convertible Mark' },
  { code: 'band', name: 'Band Protocol' },
  { code: 'bat', name: 'Basic Attention Token' },
  { code: 'bbd', name: 'Barbadian Dollar' },
  { code: 'bch', name: 'Bitcoin Cash' },
  { code: 'bdt', name: 'Bangladeshi Taka' },
  { code: 'bgn', name: 'Bulgarian Lev' },
  { code: 'bhd', name: 'Bahraini Dinar' },
  { code: 'bico', name: 'Biconomy' },
  { code: 'bif', name: 'Burundian Franc' },
  { code: 'bit', name: 'BitDAO' },
  { code: 'blur', name: 'Blur' },
  { code: 'blz', name: 'Bluzelle' },
  { code: 'bmd', name: 'Bermudian Dollar' },
  { code: 'bnb', name: 'Binance Coin' },
  { code: 'bnd', name: 'Brunei Dollar' },
  { code: 'bnt', name: 'Bancor Network' },
  { code: 'bob', name: 'Bolivian Boliviano' },
  { code: 'boba', name: 'Boba Network' },
  { code: 'bond', name: 'BarnBridge' },
  { code: 'brl', name: 'Brazilian Real' },
  { code: 'bsd', name: 'Bahamian Dollar' },
  { code: 'bsv', name: 'Bitcoin SV' },
  { code: 'bsw', name: 'Biswap' },
  { code: 'btc', name: 'Bitcoin' },
  { code: 'btcb', name: 'Bitcoin BEP2' },
  { code: 'btg', name: 'Bitcoin Gold' },
  { code: 'btn', name: 'Bhutanese Ngultrum' },
  { code: 'btrst', name: 'Braintrust' },
  { code: 'busd', name: 'Binance USD' },
  { code: 'bwp', name: 'Botswanan Pula' },
  { code: 'byn', name: 'New Belarusian Ruble' },
  { code: 'byr', name: 'Belarusian Ruble' },
  { code: 'bzd', name: 'Belize Dollar' },
  { code: 'c98', name: 'Coin98' },
  { code: 'cad', name: 'Canadian Dollar' },
  { code: 'cake', name: 'PancakeSwap' },
  { code: 'cbeth', name: 'Coinbase Wrapped Staked ETH' },
  { code: 'cdf', name: 'Congolese Franc' },
  { code: 'celo', name: 'Celo' },
  { code: 'celr', name: 'Celer Network' },
  { code: 'cgld', name: 'Celo Gold' },
  { code: 'chf', name: 'Swiss Franc' },
  { code: 'chz', name: 'Chiliz' },
  { code: 'clp', name: 'Chilean Peso' },
  { code: 'clv', name: 'Clover Finance' },
  { code: 'cnh', name: 'Chinese Yuan Renminbi Offshore' },
  { code: 'cny', name: 'Chinese Yuan Renminbi' },
  { code: 'comp', name: 'Compound' },
  { code: 'cop', name: 'Colombian Peso' },
  { code: 'coti', name: 'COTI' },
  { code: 'coval', name: 'COVAL' },
  { code: 'crc', name: 'Costa Rican Colon' },
  { code: 'cro', name: 'Crypto.com Chain' },
  { code: 'crpt', name: 'Crypterium' },
  { code: 'crv', name: 'Curve DAO Token' },
  { code: 'ctsi', name: 'Cartesi' },
  { code: 'ctx', name: 'Cryptex Finance' },
  { code: 'cuc', name: 'Cuban Convertible Peso' },
  { code: 'cup', name: 'Cuban Peso' },
  { code: 'cvc', name: 'Civic' },
  { code: 'cve', name: 'Cape Verdean Escudo' },
  { code: 'cvx', name: 'Convex Finance' },
  { code: 'czk', name: 'Czech Koruna' },
  { code: 'dai', name: 'DAI' },
  { code: 'dar', name: 'Mines of Dalarnia' },
  { code: 'dash', name: 'Digital Cash' },
  { code: 'dcr', name: 'Decred' },
  { code: 'ddx', name: 'DerivaDAO' },
  { code: 'deso', name: 'Decentralized Social' },
  { code: 'dext', name: 'DEXTools' },
  { code: 'dfi', name: 'DfiStarter' },
  { code: 'dia', name: 'Dia' },
  { code: 'dimo', name: 'DIMO' },
  { code: 'djf', name: 'Djibouti Franc' },
  { code: 'dkk', name: 'Danish Krone' },
  { code: 'dnt', name: 'District0x' },
  { code: 'doge', name: 'Dogecoin' },
  { code: 'dop', name: 'Dominican Peso' },
  { code: 'dot', name: 'Polkadot' },
  { code: 'drep', name: 'Drep [new]' },
  { code: 'dyp', name: 'DeFi Yield Protocol' },
  { code: 'dzd', name: 'Algerian Dinar' },
  { code: 'eek', name: 'Estonian Kroon' },
  { code: 'egld', name: 'Elrond' },
  { code: 'egp', name: 'Egyptian Pound' },
  { code: 'ela', name: 'Elastos' },
  { code: 'enj', name: 'Enjin Coin' },
  { code: 'ens', name: 'Ethereum Name Service' },
  { code: 'eos', name: 'EOS' },
  { code: 'ern', name: 'Eritrean Nakfa' },
  { code: 'etb', name: 'Ethiopian Birr' },
  { code: 'etc', name: 'Ethereum Classic' },
  { code: 'eth', name: 'Ethereum' },
  { code: 'eth2', name: 'Ethereum 2.0' },
  { code: 'eur', name: 'Euro' },
  { code: 'euroc', name: 'Euro Coin' },
  { code: 'farm', name: 'Harvest Finance' },
  { code: 'fei', name: 'Fei USD' },
  { code: 'fet', name: 'Fetch.ai' },
  { code: 'fida', name: 'Bonfida' },
  { code: 'fil', name: 'Filecoin' },
  { code: 'fis', name: 'Stafi' },
  { code: 'fjd', name: 'Fiji Dollar' },
  { code: 'fkp', name: 'Falkland Islands Pound' },
  { code: 'flow', name: 'Flow' },
  { code: 'flr', name: 'FLARE' },
  { code: 'fort', name: 'Forta' },
  { code: 'forth', name: 'Ampleforth Governance Token' },
  { code: 'fox', name: 'Shapeshift FOX Token' },
  { code: 'frax', name: 'Frax' },
  { code: 'ftm', name: 'Fantom' },
  { code: 'ftt', name: 'FarmaTrust' },
  { code: 'fx', name: 'Function X' },
  { code: 'gal', name: 'Project Galaxy' },
  { code: 'gala', name: 'Gala' },
  { code: 'gbp', name: 'Pound Sterling' },
  { code: 'gel', name: 'Georgian Lari' },
  { code: 'gfi', name: 'Goldfinch' },
  { code: 'ggp', name: 'Guernsey Pound' },
  { code: 'ghs', name: 'Ghanaian Cedi' },
  { code: 'ghst', name: 'Aavegotchi' },
  { code: 'gip', name: 'Gibraltar Pound' },
  { code: 'glm', name: 'Golem' },
  { code: 'gmd', name: 'Gambian Dalasi' },
  { code: 'gmt', name: 'Stepn' },
  { code: 'gnf', name: 'Guinean Franc' },
  { code: 'gno', name: 'Gnosis' },
  { code: 'gnt', name: 'GreenTrust' },
  { code: 'gods', name: 'Gods Unchained' },
  { code: 'grt', name: 'The Graph' },
  { code: 'gst', name: 'Green Satoshi Token' },
  { code: 'gt', name: 'GateToken' },
  { code: 'gtc', name: 'Gitcoin' },
  { code: 'gtq', name: 'Guatemalan Quetzal' },
  { code: 'gusd', name: 'Gemini US Dollar' },
  { code: 'gyd', name: 'Guyana Dollar' },
  { code: 'gyen', name: 'GYEN' },
  { code: 'hbar', name: 'Hedera' },
  { code: 'hft', name: 'Hashflow' },
  { code: 'high', name: 'Highstreet' },
  { code: 'hkd', name: 'Hong Kong Dollar' },
  { code: 'hnl', name: 'Honduran Lempira' },
  { code: 'hnt', name: 'Helium' },
  { code: 'hopr', name: 'HOPR' },
  { code: 'hot', name: 'Hydro Protocol' },
  { code: 'hrk', name: 'Croatian Kuna' },
  { code: 'ht', name: 'Huobi Token' },
  { code: 'htg', name: 'Haitian Gourde' },
  { code: 'huf', name: 'Hungarian Forint' },
  { code: 'icp', name: 'Internet Computer' },
  { code: 'idex', name: 'IDEX' },
  { code: 'idr', name: 'Indonesian Rupiah' },
  { code: 'ils', name: 'New Israeli Sheqel' },
  { code: 'ilv', name: 'Illuvium' },
  { code: 'imp', name: 'Isle of Man Pound' },
  { code: 'imx', name: 'Immutable X' },
  { code: 'index', name: 'Index Cooperative' },
  { code: 'inj', name: 'Injective' },
  { code: 'inr', name: 'Indian Rupee' },
  { code: 'inv', name: 'Inverse Finance' },
  { code: 'iotx', name: 'IoTeX' },
  { code: 'iqd', name: 'Iraqi Dinar' },
  { code: 'irr', name: 'Iranian Rial' },
  { code: 'isk', name: 'Iceland Krona' },
  { code: 'jasmy', name: 'Jasmy' },
  { code: 'jep', name: 'Jersey Pound' },
  { code: 'jmd', name: 'Jamaican Dollar' },
  { code: 'jod', name: 'Jordanian Dinar' },
  { code: 'jpy', name: 'Japanese Yen' },
  { code: 'jup', name: 'Jupiter' },
  { code: 'kas', name: '' },
  { code: 'kava', name: 'Kava' },
  { code: 'kcs', name: 'Kucoin' },
  { code: 'kda', name: 'Kadena' },
  { code: 'keep', name: 'Keep Network' },
  { code: 'kes', name: 'Kenyan Shilling' },
  { code: 'kgs', name: 'Kyrgyzstani Som' },
  { code: 'khr', name: 'Cambodian Riel' },
  { code: 'klay', name: 'Klaytn' },
  { code: 'kmf', name: 'Comorian Franc' },
  { code: 'knc', name: 'Kyber Network Crystals' },
  { code: 'kpw', name: 'North Korean Won' },
  { code: 'krl', name: 'Kryll' },
  { code: 'krw', name: 'South Korean Won' },
  { code: 'ksm', name: 'Kusama' },
  { code: 'kwd', name: 'Kuwaiti Dinar' },
  { code: 'kyd', name: 'Cayman Islands Dollar' },
  { code: 'kzt', name: 'Kazakhstani Tenge' },
  { code: 'lak', name: 'Laotian Kip' },
  { code: 'lbp', name: 'Lebanese Pound' },
  { code: 'lcx', name: 'LCX' },
  { code: 'ldo', name: 'Lido DAO Token' },
  { code: 'leo', name: 'LEOcoin' },
  { code: 'link', name: 'Chainlink' },
  { code: 'lit', name: 'Litentry' },
  { code: 'lkr', name: 'Sri Lankan Rupee' },
  { code: 'loka', name: 'League of Kingdoms Arena' },
  { code: 'loom', name: 'Loom Network' },
  { code: 'lpt', name: 'Livepeer (LPT)' },
  { code: 'lqty', name: 'Liquity' },
  { code: 'lrc', name: 'Loopring' },
  { code: 'lrd', name: 'Liberian Dollar' },
  { code: 'lseth', name: 'Liquid Staked Ethereum' },
  { code: 'lsl', name: 'Lesotho Loti' },
  { code: 'ltc', name: 'Litecoin' },
  { code: 'ltl', name: 'Lithuanian Litas' },
  { code: 'luna', name: 'Luna Coin' },
  { code: 'lvl', name: 'Latvian Lats' },
  { code: 'lyd', name: 'Libyan Dinar' },
  { code: 'mad', name: 'Moroccan Dirham' },
  { code: 'magic', name: 'MAGIC' },
  { code: 'mana', name: 'Mana Coin Decentraland' },
  { code: 'mask', name: 'Mask Network' },
  { code: 'math', name: 'MATH' },
  { code: 'matic', name: 'Polygon' },
  { code: 'mco2', name: 'Moss Carbon Credit' },
  { code: 'mdl', name: 'Moldovan Leu' },
  { code: 'mdt', name: 'Measurable Data Token' },
  { code: 'media', name: 'Media Network' },
  { code: 'metis', name: 'MetisDAO' },
  { code: 'mga', name: 'Malagasy Ariary' },
  { code: 'mina', name: 'Mina' },
  { code: 'miota', name: 'IOTA' },
  { code: 'mir', name: 'Mirror Protocol' },
  { code: 'mkd', name: 'Macedonian Denar' },
  { code: 'mkr', name: 'Maker' },
  { code: 'mln', name: 'Enzyme' },
  { code: 'mmk', name: 'Burmese Kyat' },
  { code: 'mnde', name: 'Marinade' },
  { code: 'mnt', name: 'Mongolian Tögrög' },
  { code: 'mona', name: 'Monavale' },
  { code: 'mop', name: 'Macau Pataca' },
  { code: 'mpl', name: 'Maple' },
  { code: 'mro', name: 'Mauritanian Ouguiya' },
  { code: 'mru', name: 'Mauritanian Ouguiya' },
  { code: 'msol', name: 'Marinade Staked SOL' },
  { code: 'mtl', name: 'Maltese Lira' },
  { code: 'multi', name: 'Multichain' },
  { code: 'mur', name: 'Mauritius Rupee' },
  { code: 'musd', name: 'mStableUSD' },
  { code: 'muse', name: 'Muse' },
  { code: 'mvr', name: 'Maldivian Rufiyaa' },
  { code: 'mwk', name: 'Malawian Kwacha' },
  { code: 'mxc', name: 'MXC' },
  { code: 'mxn', name: 'Mexican Peso' },
  { code: 'myr', name: 'Malaysian Ringgit' },
  { code: 'mzn', name: 'Mozambican Metical' },
  { code: 'nad', name: 'Namibian Dollar' },
  { code: 'nct', name: 'Polyswarm' },
  { code: 'near', name: 'NEAR Protocol' },
  { code: 'neo', name: 'NEO' },
  { code: 'nest', name: 'NEST Protocol' },
  { code: 'nexo', name: 'NEXO' },
  { code: 'ngn', name: 'Nigerian Naira' },
  { code: 'nio', name: 'Nicaraguan Córdoba' },
  { code: 'nkn', name: 'NKN' },
  { code: 'nmr', name: 'Numeraire Network' },
  { code: 'nok', name: 'Norwegian Krone' },
  { code: 'npr', name: 'Nepalese Rupee' },
  { code: 'nu', name: 'NuCypher' },
  { code: 'nzd', name: 'New Zealand Dollar' },
  { code: 'ocean', name: 'Ocean Protocol' },
  { code: 'ogn', name: 'Origin Token' },
  { code: 'okb', name: 'Okex' },
  { code: 'omg', name: 'Omisego' },
  { code: 'omr', name: 'Omani Rial' },
  { code: 'one', name: 'Menlo One' },
  { code: 'ooki', name: 'Ooki Protocol' },
  { code: 'op', name: 'Optimism' },
  { code: 'orca', name: 'Orca' },
  { code: 'orn', name: 'Orion Protocol' },
  { code: 'osmo', name: 'Osmosis' },
  { code: 'oxt', name: 'Orchid Network' },
  { code: 'pab', name: 'Panamanian Balboa' },
  { code: 'pax', name: 'Paxos Standard Token' },
  { code: 'paxg', name: 'PAX Gold' },
  { code: 'pen', name: 'Peruvian Sol' },
  { code: 'perp', name: 'Perpetual Protocol' },
  { code: 'pgk', name: 'Papua New Guinean Kina' },
  { code: 'php', name: 'Philippine Piso' },
  { code: 'pkr', name: 'Pakistani Rupee' },
  { code: 'pla', name: 'PlayDapp' },
  { code: 'pln', name: 'Polish Zloty' },
  { code: 'plu', name: 'Pluton' },
  { code: 'png', name: 'Pangolin' },
  { code: 'pols', name: 'Polkastarter' },
  { code: 'poly', name: 'Polymath' },
  { code: 'pond', name: 'Marlin' },
  { code: 'powr', name: 'Powerledger' },
  { code: 'prime', name: 'Echelon Prime' },
  { code: 'pro', name: 'Propy' },
  { code: 'prq', name: 'PARSIQ' },
  { code: 'pundix', name: 'Pundi X (New)' },
  { code: 'pyg', name: 'Paraguayan Guaraní' },
  { code: 'pyr', name: 'Vulcan Forged PYR' },
  { code: 'qar', name: 'Qatari Rial' },
  { code: 'qi', name: 'BENQI' },
  { code: 'qnt', name: 'Quant' },
  { code: 'qsp', name: 'Quantstamp' },
  { code: 'qtum', name: 'QTUM' },
  { code: 'quick', name: 'QuickSwap' },
  { code: 'rad', name: 'Radicle' },
  { code: 'rai', name: 'Rai Reflex Index' },
  { code: 'rare', name: 'SuperRare' },
  { code: 'rari', name: 'Rarible' },
  { code: 'rbn', name: 'Ribbon FInance' },
  { code: 'ren', name: 'renBTC' },
  { code: 'rep', name: 'Augur' },
  { code: 'repv2', name: 'REPv2' },
  { code: 'req', name: 'Request' },
  { code: 'rgt', name: 'Rari Governance Token' },
  { code: 'rlc', name: 'iExec RLC' },
  { code: 'rly', name: 'Rally' },
  { code: 'rndr', name: 'Render Token' },
  { code: 'ron', name: 'Romanian Leu' },
  { code: 'rose', name: 'Oasis Network' },
  { code: 'rpl', name: 'Rocket Pool' },
  { code: 'rsd', name: 'Serbian Dinar' },
  { code: 'rub', name: 'Russian Ruble' },
  { code: 'rune', name: 'THORChain (ERC20)' },
  { code: 'rvn', name: 'Ravencoin' },
  { code: 'rwf', name: 'Rwandan Franc' },
  { code: 'sand', name: 'The Sandbox' },
  { code: 'sar', name: 'Saudi Riyal' },
  { code: 'sbd', name: 'Solomon Islands Dollar' },
  { code: 'scr', name: 'Seychellois Rupee' },
  { code: 'sdg', name: 'Sudanese Pound' },
  { code: 'sek', name: 'Swedish Krona' },
  { code: 'sgd', name: 'Singapore Dollar' },
  { code: 'shib', name: 'Shiba Inu' },
  { code: 'shp', name: 'Saint Helena Pound' },
  { code: 'shping', name: 'Shping Coin' },
  { code: 'skk', name: 'Slovak Koruna' },
  { code: 'skl', name: 'SKALE Network' },
  { code: 'sle', name: 'Sierra Leonean Leone' },
  { code: 'sll', name: 'Sierra Leonean Leone' },
  { code: 'snt', name: 'Status Network' },
  { code: 'snx', name: 'Synthetix Network' },
  { code: 'sol', name: 'Solana' },
  { code: 'sos', name: 'Somali Shilling' },
  { code: 'spa', name: 'Sperax' },
  { code: 'spell', name: 'Spell Token' },
  { code: 'srd', name: 'Surinamese Dollar' },
  { code: 'std', name: 'São Tomé and Príncipe Dobra' },
  { code: 'stg', name: 'Stargate Finance' },
  { code: 'stn', name: 'São Tomé and Príncipe Dobra' },
  { code: 'storj', name: 'Storj' },
  { code: 'stx', name: 'Stacks' },
  { code: 'sui', name: 'Sui' },
  { code: 'suku', name: 'SUKU' },
  { code: 'super', name: 'SuperFarm' },
  { code: 'sushi', name: 'SushiSwap' },
  { code: 'svc', name: 'Salvadoran Colón' },
  { code: 'swftc', name: 'SwftCoin' },
  { code: 'sylo', name: 'Sylo' },
  { code: 'syn', name: 'Synapse' },
  { code: 'syp', name: 'Syrian Pound' },
  { code: 'szl', name: 'Swazi Lilangeni' },
  { code: 't', name: 'Threshold' },
  { code: 'thb', name: 'Thai Baht' },
  { code: 'theta', name: 'Theta' },
  { code: 'time', name: 'Chrono.tech' },
  { code: 'tjs', name: 'Tajikistani Somoni' },
  { code: 'tmm', name: 'Turkmenistan Manat' },
  { code: 'tmt', name: 'Turkmenistani Manat' },
  { code: 'tnd', name: 'Tunisian Dinar' },
  { code: 'ton', name: 'Tokamak Network' },
  { code: 'tone', name: 'TE-FOOD' },
  { code: 'top', name: 'Tongan Paʻanga' },
  { code: 'trac', name: 'OriginTrail' },
  { code: 'trb', name: 'Tellor' },
  { code: 'tribe', name: 'Tribe' },
  { code: 'tru', name: 'TrueFi' },
  { code: 'trx', name: 'TRON' },
  { code: 'try', name: 'Turkish Lira' },
  { code: 'ttd', name: 'Trinidad and Tobago Dollar' },
  { code: 'ttt', name: 'Tap Project' },
  { code: 'tusd', name: 'True USD' },
  { code: 'tvk', name: 'Terra Virtua Kolect' },
  { code: 'twd', name: 'New Taiwan Dollar' },
  { code: 'tzs', name: 'Tanzanian Shilling' },
  { code: 'uah', name: 'Ukrainian Hryvnia' },
  { code: 'ugx', name: 'Uganda Shilling' },
  { code: 'uma', name: 'Universal Market Access' },
  { code: 'unfi', name: 'Unifi Protocol DAO' },
  { code: 'uni', name: 'Uniswap' },
  { code: 'upi', name: 'Pawtocol' },
  { code: 'usd', name: 'US Dollar' },
  { code: 'usdc', name: 'USDC' },
  { code: 'usdp', name: 'USDP Stablecoin' },
  { code: 'usdt', name: 'Tether' },
  { code: 'ust', name: 'TerraUSD' },
  { code: 'uyu', name: 'Uruguayan Peso' },
  { code: 'uzs', name: 'Uzbekistani Som' },
  { code: 'vef', name: 'Venezuelan Bolívar Fuerte' },
  { code: 'ves', name: 'Venezuelan Bolívar' },
  { code: 'vet', name: 'Vechain' },
  { code: 'vgx', name: 'Voyager Token' },
  { code: 'vnd', name: 'Vietnamese Dong' },
  { code: 'voxel', name: 'Voxies' },
  { code: 'vuv', name: 'Vanuatu Vatu' },
  { code: 'wampl', name: 'Wrapped Ampleforth' },
  { code: 'waves', name: 'Waves' },
  { code: 'waxl', name: 'Axelar' },
  { code: 'wbtc', name: 'Wrapped Bitcoin' },
  { code: 'wcfg', name: 'Wrapped Centrifuge' },
  { code: 'wemix', name: 'WEMIX' },
  { code: 'wluna', name: 'Wrapped LUNA' },
  { code: 'wst', name: 'Samoan Tālā' },
  { code: 'xaf', name: 'Central African CFA franc' },
  { code: 'xag', name: 'Silver (troy ounce)' },
  { code: 'xau', name: 'Gold (troy ounce)' },
  { code: 'xcd', name: 'East Caribbean Dollar' },
  { code: 'xch', name: 'Chia' },
  { code: 'xcn', name: 'Chain' },
  { code: 'xdc', name: 'XDC Network' },
  { code: 'xdr', name: 'Special Drawing Rights' },
  { code: 'xec', name: 'Eternal Coin' },
  { code: 'xem', name: 'NEM' },
  { code: 'xlm', name: 'Stellar' },
  { code: 'xmon', name: 'XMON' },
  { code: 'xmr', name: 'Monero' },
  { code: 'xof', name: 'West African CFA Franc' },
  { code: 'xpd', name: 'Palladium' },
  { code: 'xpf', name: 'CFP Franc' },
  { code: 'xpt', name: 'Platinum' },
  { code: 'xrp', name: 'Ripple' },
  { code: 'xtz', name: 'Tezos' },
  { code: 'xyo', name: 'XYO Network' },
  { code: 'yer', name: 'Yemeni Rial' },
  { code: 'yfi', name: 'Yearn Finance' },
  { code: 'yfii', name: 'DFI.Money' },
  { code: 'zar', name: 'South African Rand' },
  { code: 'zec', name: 'ZCash' },
  { code: 'zen', name: 'Horizen' },
  { code: 'zil', name: 'Zilliqa' },
  { code: 'zmk', name: 'Zambian Kwacha' },
  { code: 'zmw', name: 'Zambian Kwacha' },
  { code: 'zrx', name: 'ZRX 0x' },
  { code: 'zwd', name: 'Zimbabwean Dollar' },
  { code: 'zwl', name: 'Zimbabwean Dollar' },
]
